/**
 * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-icon.scss'
import luiIconManager from './lui-icon-manager'

export default class LuiIcon extends LuiBase {
  static get is() {
    return 'lui-icon'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return ''
  }

  static get hasLuiElementsInShadowDom() {
    return false
  }

  iconChanged() {
    luiIconManager.getIcon(this.getAttribute('icon'))
      .then((svgSource) => {
        const div = document.createElement('div')
        div.innerHTML = svgSource
        if (this.svgElement) this.shadowRoot.removeChild(this.svgElement)
        this.svgElement = div.querySelector('svg')
        this.shadowRoot.appendChild(this.svgElement)
      }).catch((error) => {
        console.error('Error:', error)
      })
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-icon/lui-icon.js
// module id = 215
// module chunks = 0 1 12